import { GroupedFolder } from "~/gql/types2";
import { FolderRequestType } from "../types";
import { FieldState, FormState } from "~/components/inline-fields-form/types";

export type FolderFormData = {
  folderType: FolderRequestType | null;
  projectFolderDriveLetter: string | null;
  newGroupedFolderName: string | null;
  newGroupedFolderDriveLetter: string | null;
  groupedFolder: GroupedFolder | null;
};

const initialFormValues: FolderFormData = {
  folderType: FolderRequestType.Single,
  projectFolderDriveLetter: null,
  newGroupedFolderName: null,
  newGroupedFolderDriveLetter: null,
  groupedFolder: null,
};

export const initialFieldState: FieldState[] = [
  {
    name: "folderType",
    required: true,
    value: initialFormValues.folderType,
  },
  {
    name: "projectFolderDriveLetter",
    required: initialFormValues.folderType == FolderRequestType.Single,
    value: initialFormValues.projectFolderDriveLetter,
  },
  {
    name: "newGroupedFolderName",
    required: false,
    value: initialFormValues.newGroupedFolderName,
  },
  {
    name: "newGroupedFolderDriveLetter",
    required: false,
    value: initialFormValues.newGroupedFolderDriveLetter,
  },
  {
    name: "groupedFolder",
    required: false,
    value: initialFormValues.groupedFolder,
  },
];

const updateState = (
  state: FormState,
  updatedFields: Record<string, FieldState>
) => ({
  ...state,
  fields: {
    ...state.fields,
    ...updatedFields,
  },
});

const updateRequired = (
  state: FormState,
  field: string,
  required: boolean
) => ({
  [field]: { ...state.fields[field], required, error: "" },
});

export const updater = {
  folderType: (state: FormState, value: FolderRequestType): FormState =>
    updateState(state, {
      ...updateRequired(
        state,
        "groupedFolder",
        value == FolderRequestType.ExistingGrouped
      ),
      ...updateRequired(
        state,
        "projectFolderDriveLetter",
        value == FolderRequestType.Single
      ),
      ...updateRequired(
        state,
        "newGroupedFolderName",
        value == FolderRequestType.NewGrouped
      ),
      ...updateRequired(
        state,
        "newGroupedFolderDriveLetter",
        value == FolderRequestType.NewGrouped
      ),
    }),
};
